import { render, staticRenderFns } from "./AddProductUnit.vue?vue&type=template&id=4d3f0c4e&"
import script from "./AddProductUnit.vue?vue&type=script&lang=js&"
export * from "./AddProductUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports